import { colors } from 'style/colors';

export const getCompanyColor = () =>
  process.env.REACT_APP_COMPANY === 'HX' ? colors.hrx.blue : colors.shared.red;
